import { ColumnTypeEnum, GbTableColumn } from '@galabid/gb-dashboard/shared/feature'

export const initialDisplayColumns: GbTableColumn[] = [
  {
    columnKey: 'order',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.ORDER',
    columnType: ColumnTypeEnum.Reorder,
  },
  {
    columnKey: 'image',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.IMAGE',
    columnType: ColumnTypeEnum.Template,
    disableSort: true,
  },
  {
    columnKey: 'name',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.NAME',
    columnType: ColumnTypeEnum.Label,
  },
  {
    columnKey: 'type',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.TYPE',
    columnType: ColumnTypeEnum.Label,
  },
  {
    columnKey: 'price',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.PRICE',
    columnType: ColumnTypeEnum.Currency,
  },
  {
    columnKey: 'is_visible',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.VISIBILITY',
    columnType: ColumnTypeEnum.Visibility,
  },
  {
    columnKey: 'tickets_sold_progress',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.NUMBER_SOLD',
    columnType: ColumnTypeEnum.Progress,
  },
  {
    columnKey: 'request_invoice_pending_total',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.REQUEST_INVOICE_TOTAL',
    columnType: ColumnTypeEnum.Label,
  },
  {
    columnKey: 'actions',
    columnLabel: 'ACTIONS',
    columnType: ColumnTypeEnum.Actions,
  },
]

export const additionalDisplayColumns: GbTableColumn[] = [
  {
    columnKey: 'lock_status',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.LOCK',
    columnType: ColumnTypeEnum.Label,
  },
  {
    columnKey: 'tax',
    columnLabel: 'EVENT_TICKET_PACKAGES.LIST.TAX',
    columnType: ColumnTypeEnum.Label,
  },
]
